import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import translationsUI from '../translationUI';
const LoadingBtn = () => {
  const intl = useIntl();
  return (
    <Fragment>
      <span
        className="spinner-grow spinner-grow-sm"
        role="status"
        aria-hidden="true"
        style={{
          position: 'absolute',
          left: '5px',
          top: '11px',
          transition: `all .5s ease`,
        }}
      />
      {intl.formatMessage(translationsUI.PAVE_PROCESS_LOADING_BTN)}
    </Fragment>
  );
};

export default LoadingBtn;
